import {
  ReactNode, useState, useEffect, ReactChild, useRef,
} from 'react';
import { gondolaBreakpoints } from 'themes/muiTheme';

interface Props {
  children: ReactChild[];
}

const DEFAULT_COLUMNS = 1;

export const Masonry = ({ children }: Props) => {
  const [columns, setColumns] = useState(DEFAULT_COLUMNS);
  const masonryRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const breakPoints = [
      gondolaBreakpoints.sm,
      gondolaBreakpoints.md,
      gondolaBreakpoints.lg,
      gondolaBreakpoints.xl,
      gondolaBreakpoints.xxl,
    ];
    const getColumns = (w: number = 1) => (
      breakPoints.reduceRight((p, c, i) => (c <= w ? p : i), DEFAULT_COLUMNS) + 1
    );

    const onResize = () => {
      const newColumns = getColumns(masonryRef?.current?.offsetWidth);
      if (newColumns !== columns) {
        setColumns(newColumns);
      }
    };

    onResize();
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [columns]);

  /* this function loops through children and put them into 2 dimension col array */
  const mapChildren = () => {
    const col: ReactChild[][] = [];
    const numC = columns;
    for (let i = 0; i < numC; i += 1) {
      col.push([] as ReactChild[]);
    }
    return children.reduce((p: ReactChild[][], c: ReactChild, i: number) => {
      p[i % numC]?.push(c);
      return p;
    }, col);
  };

  const getGridCols = () => {
    switch (columns) {
    case 2:
      return 'grid-cols-2';
    case 3:
      return 'grid-cols-3';
    case 4:
      return 'grid-cols-4';
    case 5:
      return 'grid-cols-5';
    case 6:
      return 'grid-cols-6';
    default:
      return '';
    }
  };

  return (
    <div className={`grid gap-6 ${getGridCols()}`} ref={masonryRef}>
      {mapChildren().map((col: ReactNode, i: number) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="flex-col sm:max-w-xs" key={i}>
          {col}
        </div>
      ))}
    </div>
  );
};
